import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { resetStatus } from "../../services/slice/StoreSlice";
import { storeProductSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import NoSearchResults from "../../components/common/NoSearchResults";
import { useState } from "react";

import { exportReportBanner } from "../../services/slice/statisticsSlice";
import HeaderSort from "../../components/common/HeaderSort";
import TableBannerStatistics from "../../components/common/Table/TableBannerStatistics";
const BannerStatistics = () => {
  const stateStore = useSelector(storeProductSelector);
  const [valueSearch, setValueSearch] = useState("");
  const [config, setConfig] = useState({
    search: "",
    properties: "views",
    typeTime: -1,
    option: {
      limit: 10,
      offset: 1,
      order: "asc",
    },
  });
  return (
    <div className="wrapperStoreManager">
      <Notify
        isNotify={stateStore.isNotify}
        reset={resetStatus}
        title={"Bkav Pro"}
        content={stateStore.msg}
        type={stateStore.typeNotify}
      />
      <HeaderSort
        config={config}
        handleExport={exportReportBanner}
        setValueSearch={setValueSearch}
        title={"Thống kê tương tác với banner"}
        setConfig={setConfig}
      />
      <Row>
        {stateStore.config.search && !stateStore.data.length ? (
          <NoSearchResults />
        ) : (
          <TableBannerStatistics
            setConfig={setConfig}
            config={config}
            valueSearch={valueSearch}
          />
        )}
      </Row>
    </div>
  );
};

export default BannerStatistics;
